/* 4s product cards — global swatch + quick-add behavior (delegated once). */
(function () {
  if (window.__fsCardsInit) return;
  window.__fsCardsInit = true;

  document.addEventListener('click', function (evt) {
    var swatch = evt.target.closest('[data-fs-swatch]');
    if (swatch) {
      evt.preventDefault();
      var card = swatch.closest('[data-fs-card]');
      if (!card) return;
      card.querySelectorAll('[data-fs-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
      var img = card.querySelector('.fs-card__img');
      if (img && swatch.dataset.image) {
        img.src = swatch.dataset.image;
        img.removeAttribute('srcset');
      }
      if (swatch.dataset.variantId) {
        card.dataset.variantId = swatch.dataset.variantId;
        card.dataset.available = swatch.dataset.available;
        var btn = card.querySelector('[data-fs-quick-add]');
        if (btn && btn.tagName === 'BUTTON') {
          var available = swatch.dataset.available === 'true';
          btn.disabled = !available;
          btn.textContent = available
            ? (window.__fsStrings && __fsStrings.add) || 'Add to cart'
            : (window.__fsStrings && __fsStrings.soldOut) || 'Sold out';
        }
      }
      return;
    }

    var addBtn = evt.target.closest('[data-fs-quick-add]');
    if (addBtn && addBtn.tagName === 'BUTTON') {
      evt.preventDefault();
      var card2 = addBtn.closest('[data-fs-card]');
      var variantId = card2 && card2.dataset.variantId;
      if (!variantId || addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          addBtn.classList.remove('is-loading');
          if (data.status === 422) {
            addBtn.disabled = true;
            addBtn.textContent = (window.__fsStrings && __fsStrings.soldOut) || 'Sold out';
            return;
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: addBtn }
          }));
        })
        .catch(function () { addBtn.classList.remove('is-loading'); });
    }
  });
})();
